import { Component, Host, h, Element } from '@stencil/core';

export interface AhaEmptyStateSmall extends HTMLAhaEmptyStateSmallElement {}

/**
 * Basic empty state component.
 * @slot default - Contents of the `aha-empty-state-small` component.
 */
@Component({
  tag: 'aha-empty-state-small',
  styleUrl: 'aha-empty-state-small.css',
  shadow: true,
})
export class AhaEmptyStateSmall {
  @Element() host!: HTMLAhaEmptyStateSmallElement;
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
